import { render, staticRenderFns } from "./PhotoKeychain.vue?vue&type=template&id=25036f98"
import script from "./PhotoKeychain.vue?vue&type=script&lang=js"
export * from "./PhotoKeychain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports